
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M9.436 1.515c.663-.97 2.18-.476 2.148.698a1.177 1.177 0 001.572 1.141c1.106-.393 2.044.898 1.328 1.828a1.178 1.178 0 00.6 1.848c1.127.332 1.127 1.927 0 2.26a1.177 1.177 0 00-.6 1.847c.716.93-.222 2.22-1.328 1.827a1.178 1.178 0 00-1.572 1.142c.033 1.174-1.485 1.667-2.148.698a1.177 1.177 0 00-1.943 0c-.663.969-2.18.476-2.148-.698a1.178 1.178 0 00-1.572-1.142c-1.106.394-2.044-.897-1.328-1.827a1.177 1.177 0 00-.6-1.848c-1.127-.332-1.127-1.927 0-2.26a1.177 1.177 0 00.6-1.847c-.716-.93.222-2.221 1.328-1.828a1.177 1.177 0 001.572-1.141C5.312 1.039 6.83.546 7.493 1.515a1.177 1.177 0 001.943 0","fill":"#12849A"}}),_c('path',{attrs:{"d":"M9.436 1.515c.663-.97 2.18-.476 2.148.698a1.177 1.177 0 001.572 1.141c1.106-.393 2.044.898 1.328 1.828a1.178 1.178 0 00.6 1.848c1.127.332 1.127 1.927 0 2.26a1.177 1.177 0 00-.6 1.847c.716.93-.222 2.22-1.328 1.827a1.178 1.178 0 00-1.572 1.142c.033 1.174-1.485 1.667-2.148.698a1.177 1.177 0 00-1.943 0c-.663.969-2.18.476-2.148-.698a1.178 1.178 0 00-1.572-1.142c-1.106.394-2.044-.897-1.328-1.827a1.177 1.177 0 00-.6-1.848c-1.127-.332-1.127-1.927 0-2.26a1.177 1.177 0 00.6-1.847c-.716-.93.222-2.221 1.328-1.828a1.177 1.177 0 001.572-1.141C5.312 1.039 6.83.546 7.493 1.515a1.177 1.177 0 001.943 0z","stroke":"#12849A"}}),_c('path',{attrs:{"d":"M6.511 8.394l1.21 1.13 3.028-2.826","stroke":"#FFF","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    